import {Component, OnInit} from '@angular/core';
import {MemberService} from '../../services/member.service';
import {MemberModel} from '../../models/user.model';
import {AuthService} from '../../services/api/auth.service';
import {CompanyModel} from '../../models/company.model';
import {AlertService} from '../../services/notify/alert.service';

@Component({
    selector: 'app-general-project-settings',
    templateUrl: './general-project-settings.component.html',
    styleUrls: ['./general-project-settings.component.scss'],
})
export class GeneralProjectSettingsComponent implements OnInit {
    currentMember: MemberModel;
    editProject = false;
    currentProject: CompanyModel;


    constructor(
        protected memberService: MemberService,
        protected authService: AuthService,
        protected alert: AlertService,
    ) {
    }

    ngOnInit(): void {
        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
            this.currentProject = structuredClone(this.currentMember.project_setting.project);
        });
    }

    updateProject(): void {
        const data = {
            title: this.currentProject.name,
            project_type: this.currentProject.type,
            project_subtype: this.currentProject.subtype,
        };
        this.authService.updateProject(data).subscribe({
            next: res => {
                this.alert.setAlert(res.message, 'green');
            }, error: error => {
                this.alert.setAlert(error.message, 'blue');
            }
        });
    }
}
